export default __webpack_public_path__ + "static/055-d66d3c4e3632910bd50d9a49ada34e73.jpg";